import React, { useState } from 'react'
import { useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'
import { useSelector } from 'react-redux'
import { getEmotionFColor, getEmotionIcon, getEmotionSColor } from 'utils/getEmotionIcon'

function DAtenyaAi() {
   const videoRedux = useSelector((state) => state.videoRedux)
   const { loading, videoDetails: videoDetailsData } = videoRedux

   const [isPositive, setIsPositive] = useState(true)

   const [positiveArray, setPositiveArray] = useState([])
   const [negativeArray, setNegativeArray] = useState([])
   const [openShowMoreModal, setOpenShowMoreModal] = useState(false) 

   useEffect(() => {
      if (videoDetailsData) {
         if (
            videoDetailsData?.top_positive_comments &&
            videoDetailsData?.top_positive_comments?.length > 0
         ) {
            const firstThreeObjects = videoDetailsData?.top_positive_comments.slice(0, 3)
            setPositiveArray(firstThreeObjects)
         }
         if (
            videoDetailsData?.top_negative_comments &&
            videoDetailsData?.top_negative_comments?.length > 0
         ) {
            const firstThreeObjects = videoDetailsData?.top_negative_comments.slice(0, 3)
            setNegativeArray(firstThreeObjects)
         }
      } else {
         setPositiveArray([])
         setNegativeArray([])
      }

      return () => {}
   }, [videoDetailsData])

   const onCloseModal = () => {
      setOpenShowMoreModal(!openShowMoreModal)
   }

   return (
      <div className="hello-atenya-wrap">
         <div className="card">
            <div className=""> 
               <div className="d-flex gap-3 w-100 align-items-center line-chart-wrap">
                  <div className="positive-emotion line-chart-report p-0 ">
                     <div className="atenya-positive-title">
                        <div>
                           <h3 className="at-text-dark">Top 3 Positive Emotions</h3>
                           {/* <span className="at-text-light">Negative 2 min ago</span> */}
                        </div>
                     </div>

                     <EmotionsChart
                        positiveArray={positiveArray}
                        isPositive={isPositive}
                        negativeArray={negativeArray}
                     />
                     <div className="emotion-list-wrap">
                        <div className="row">
                           {positiveArray?.length > 0 &&
                              positiveArray?.map((item, i) => {
                                 return (
                                    <div className="col-5 col-sm-4 col-lg-4" key={i}>
                                       <div className="emotion-counter-wrap">
                                          <h3 className="at-text-dark">{item?.count}</h3>
                                       </div>
                                       <div className="at-text-light atenya-counter-sub-title">
                                          {getEmotionIcon(item?.text, 'positive')}
                                          <span className="ms-1 d-inline-block text-capitalize">
                                             {' '}
                                             {item?.text}{' '}
                                          </span>
                                       </div>
                                    </div>
                                 )
                              })}
                        </div>
                     </div>
                  </div>
                  <div className="positive-emotion line-chart-report p-0">
                     <div className="atenya-positive-title">
                        <div>
                           <h3 className="at-text-dark">Top 3 Negative Emotions</h3>
                           {/* <span className="at-text-light">Negative 2 min ago</span> */}
                        </div>
                     </div>

                     <EmotionsChart
                        positiveArray={positiveArray}
                        isPositive={!isPositive}
                        negativeArray={negativeArray}
                     />
                     <div className="emotion-list-wrap">
                        <div className="row">
                           {negativeArray?.length > 0 &&
                              negativeArray?.map((item, i) => {
                                 return (
                                    <div className="col-5 col-sm-4 col-lg-4" key={i}>
                                       <div className="emotion-counter-wrap">
                                          <h3 className="at-text-dark">{item?.count}</h3>
                                          {/* <small className="text-success">+2.4%</small> */}
                                       </div>
                                       <div className="at-text-light atenya-counter-sub-title">
                                          {getEmotionIcon(item?.text, 'negative')}
                                          <span className="ms-1 d-inline-block text-capitalize">
                                             {' '}
                                             {item?.text}{' '}
                                          </span>
                                       </div>
                                    </div>
                                 )
                              })}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default DAtenyaAi

const EmotionsChart = ({ positiveArray, isPositive, negativeArray }) => {
   const [series, setSeries] = useState([])
   const [options, setOptions] = useState({
      chart: {
         height: 350,
         type: 'bar',
         zoom: {
            enabled: false
         },
         toolbar: { show: false },
         brush: { enabled: false }
      },
      plotOptions: {
         bar: {
            borderRadius: 10,
            columnWidth: 50,
            distributed: true
         }
      },
      xaxis: {
         labels: {
            show: false
         }
      },
      fill: {
         type: 'gradient'
      },
      yaxis: {
         axisBorder: {
            show: false
         },
         axisTicks: {
            show: false
         },
         labels: {
            show: false
         }
      },
      legend: {
         show: false
      },
      tooltip: { enabled: false }
   })

   useEffect(() => {
      if (isPositive && positiveArray && positiveArray?.length > 1) {
         let data = []
         let fcolor = []
         let sColor = []
         positiveArray?.map((item) => fcolor.push(getEmotionFColor(item?.text || '', 'positive')))
         positiveArray?.map((item) => sColor.push(getEmotionSColor(item?.text || '', 'positive')))
         setOptions({
            ...options,
            colors: fcolor,
            fill: {
               type: 'gradient',
               gradient: {
                  shadeIntensity: 1,
                  type: 'diagonal1',
                  gradientToColors: sColor,
                  inverseColors: false,
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100]
               }
            }
         })
         positiveArray?.map((item) => data.push(item?.count))
         const aa = {
            name: 'positive',
            data: data
         }
         setSeries([aa])
      } else if (negativeArray && negativeArray.length > 1) {
         let data = []

         negativeArray?.map((item) => data.push(item?.count))
         const aa = {
            name: 'negative',
            data: data
         }
         let fcolor = []
         let sColor = []
         negativeArray?.map((item) => fcolor.push(getEmotionFColor(item?.text || '', 'negative')))
         negativeArray?.map((item) => sColor.push(getEmotionSColor(item?.text || '', 'negative')))
         setOptions({
            ...options,
            colors: fcolor,
            fill: {
               type: 'gradient',
               gradient: {
                  shadeIntensity: 1,
                  type: 'diagonal1',
                  gradientToColors: sColor,
                  inverseColors: false,
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100]
               }
            }
         })
         setSeries([aa])
      } else {
         setSeries([])
      }

      return () => {}
   }, [positiveArray, isPositive, negativeArray])

   return (
      <div>
         <div id="chart">
            {series && options && (
               <ReactApexChart options={options} series={series} type="bar" height={350} />
            )}
         </div>
         <div id="html-dist"></div>
      </div>
   )
}
